import React, { FC } from 'react';

import { getCurrentProgress } from '@services/cstool/recovery-account';

import ProgressSearch from './progress-search';

const Lobby: FC = () => (
  <ProgressSearch
    fetchProgress={getCurrentProgress}
    downloadFileName={(playerId) => `progress-${playerId}.txt`}
  />
);

export default Lobby;
